<template>
  <div>
    <v-card class="ma-2" v-if="!display">
      <v-card-text>
        <div class="text-center headline">Anda harus input data PERUSAHAAN terlebih dulu !</div>
      </v-card-text>
    </v-card>
    <v-card class="ma-2" v-if="display">
      <v-card-title  class="teal white--text">
        Pemilik Perusahaan
        <v-spacer />
        <v-btn  @click.stop="openForm(null)">
          <v-icon left>add</v-icon>
          Tambah
        </v-btn>
      </v-card-title>

      <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="pos5List"
          :items-per-page="10"
          :single-select="true"
          item-key="id"
      >
          <template v-slot:item.saham="{item}">
            {{ getSahamText(item.saham, item.satuan) }}
          </template>
          <template v-slot:item.actions="{item}">
            <v-btn icon color="cyan" @click="openForm(item)"> <v-icon>mdi-pencil</v-icon> </v-btn>
            <v-btn icon color="pink" @click="deletePemilik(item.id)"><v-icon>delete</v-icon></v-btn>
          </template>
      </v-data-table>

      <!--
      <v-card-text>
        <v-container class="">
          <v-divider />
          <v-row class="green accent-2 px-2">  
            <v-col cols="3">
              <p class="subtitle-2">                      
                Nama
              </p>
            </v-col>                
            <v-col cols="2">
              <p class="subtitle-2">                      
                No. KTP
              </p>
            </v-col>
            <v-col cols="3">
              <p class="subtitle-2">                      
                Alamat
              </p>
            </v-col>
            <v-col cols="2">
              <p class="subtitle-2">                      
                Saham
              </p>
            </v-col>
            <v-col cols="2">
              <p class="subtitle-2">                      
                -
              </p>
            </v-col>
          </v-row>
          <v-divider />
          <template v-if="pos5Count == 0">
            <v-row >
              <v-col cols="12" class="text-center">
                <p>TIDAK ADA DATA</p>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <template v-for="item in pos5List">
              <v-row :key="item.id" class="px-2">
                <v-col cols="3">
                  <div>{{ item.nama }}</div>
                </v-col>
                <v-col cols="2">
                  <div>{{ item.noKtp }}</div>
                </v-col>
                <v-col cols="3">
                  <div>{{ item.alamat }}</div>
                </v-col>
                <v-col cols="2">
                  <div>{{ getSahamText(item.saham, item.satuan) }}</div>
                </v-col>
                <v-col cols="2" align-self="start" class="pa-2">
                  <span>
                    <v-btn icon color="pink" @click="deletePemilik(item.id)"><v-icon>delete</v-icon></v-btn>
                  </span>
                </v-col>
              </v-row>
              <v-divider :key="'A'+item.nama"/>
            </template>
          </template>
          -->

          <!-- <v-row>
            <v-col cols="12">
              <v-btn color="success" dark @click.prevent="simpan5Click">
                Simpan & Lanjut
                <v-icon right large>arrow_right
                </v-icon>
              </v-btn>
            </v-col>
          </v-row> -->
          <!--
        </v-container>
      </v-card-text>
      -->

    </v-card>

    <v-dialog v-model="dlgPemilik" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Tambah Pemilik Perusahaan</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form5"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    label="Nama"
                    type="text"
                    outlined
                    v-model="pemilikNama"
                    :rules="[rules.required]"
                  />                    
                  <v-text-field
                    label="No. KTP"
                    type="text"
                    outlined
                    v-model="pemilikKtp"
                    :rules="[rules.required]"
                    class="mt-3"
                  /> 
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Alamat"
                    type="text"
                    outlined
                    v-model="pemilikAlamat"
                    :rules="[rules.required]"
                  />          
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        label="Saham"
                        type="text"
                        outlined
                        v-model="pemilikSaham"
                        :rules="[rules.required]"
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        :items="itemsPemilikSatuan"
                        label="Satuan Saham"
                        outlined
                        v-model="pemilikSatuan"
                        :rules="[rules.required]"
                        chips
                        height="50"
                      ></v-select>
                    </v-col>
                  </v-row>     
                </v-col>
              </v-row>      
              <v-row>
                <v-col cols="6">
                  <v-file-input 
                    outlined 
                    accept=".jpg,.png,.pdf"
                    label="Dokumen KTP"
                    v-model="uploadFileKTP"
                    chips
                    :rules="[validateFileKTP()]"                  
                    :placeholder="fileKTP"
                    append-icon="get_app"
                    @click:append="getLinkDownload(fileKTP)" 
                  ></v-file-input>
                </v-col>
              </v-row>          
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" dark @click="dlgPemilikSimpanClick">Simpan</v-btn>
          <v-btn color="orange" dark @click="closeForm()">Batal</v-btn>
          <v-btn color="info" dark @click="resetForm5">Reset</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>
  
    <v-dialog v-model="loginExpired" max-width="400" persistent>
        <v-card>
            <v-card-title>Login Expired</v-card-title>
                <v-card-text>Silakan Login Ulang</v-card-text>
            <v-card-actions>
                <v-btn color="red" @click="logoutClick()">Ya</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Notification -->
    <v-snackbar
        v-model="notification.show"
        :color="notification.color"
        :top="true"
        :right="true"
        :timeout=3000
    >
        {{ notification.text }}
    </v-snackbar>
  </div>
</template>

<script>
import { itemsSatuanSaham } from './../../lib/viewLib'
import { rules as Rules } from './../../lib/rules'
import axios from 'axios'
const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  data: function() {
    return {
      valid: true,
      rules: {
        required: Rules.required,
      },
      dlgPemilik: false,
      pos5Count: 0,
      pos5List: [],
      exPemilik: [
        {
          id: 199,
          nama: 'Andri',
          noKtp: '1234567890',
          alamat: 'Komplek Griya Indah jl. Nusa satu 12',
          saham: 89.75,
          satuan: 'P'
        },
        {
          id: 299,
          nama: 'Yudha',
          noKtp: '2233445566',
          alamat: 'Jln Ampera Selatan 13',
          saham: 10.25,
          satuan: 'P'
        }
      ],
      pemilikNama: '',
      pemilikKtp: '',
      pemilikAlamat: '',
      pemilikSaham: '',
      pemilikSatuan: '',
      fileKTP: "",
      itemsPemilikSatuan: itemsSatuanSaham,

      // Table headers
      headers: [
        { text: "Nama", value: "nama", class: "green accent-2 subtitle-2" },
        { text: "No. KTP", value: "noKtp", class: "green accent-2 subtitle-2" },
        { text: "Alamat", value: "alamat", class: "green accent-2 subtitle-2" },
        { text: "Saham", value: "saham", class: "green accent-2 subtitle-2" },
        { text: "", value: "actions", sortable: false,  class: "green accent-2 subtitle-2" },
      ],
      isEditing: false,
      editId: null,
      dialogEverOpened: false,
      uploadFileKTP: null,

      notification: {
          show: false,
          color: "success",
          text: ""
      },
      submitting: false,
      loginExpired: false

    }
  },
  computed: {
    display: function() {
      return this.$store.getters['ven/venId'] != -999
    },
    venId: function() { 
      return this.$store.getters['ven/venId']
    },    
  },
  methods: {
    validateFileKTP: function() {
      if (this.isEditing && this.fileKTP != "") return true;
      return this.uploadFileKTP != null || "Hasil scan KTP harus dilampirkan";
    },

    getLinkDownload: function(dok) {
      axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = dok
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },

    resetForm: function() {
      this.pemilikNama = "";
      this.pemilikKtp = "";
      this.pemilikAlamat = "";
      this.pemilikSaham = "";
      this.pemilikSatuan = "";
      this.fileKTP = "";
      this.editId = null;
      this.uploadFileKTP = null;

      if (this.dialogEverOpened) this.$refs.form5.reset();
    },
    closeForm: function() {
      this.resetForm();
      this.dlgPemilik = false;
      this.isEditing = false;
    },
    openForm: function(item) {
      this.resetForm();

      if (item) {
        this.editId = item.id;
        this.pemilikNama = item.nama;
        this.pemilikKtp = item.noKtp;
        this.pemilikAlamat = item.alamat;
        this.pemilikSaham = item.saham;
        this.pemilikSatuan = item.satuan;
        this.fileKTP = item.fileKTP;
        this.isEditing = true;
      }

      this.dlgPemilik = true;
      this.dialogEverOpened = true;
    },
    dlgPemilikSimpanClick: async function() {
      if (!this.$refs.form5.validate()) return;

      // create message untuk simpan ke database
      let newPemilik = {
        id: null,
        nama: this.pemilikNama,
        noKtp: this.pemilikKtp,
        alamat: this.pemilikAlamat,
        saham: this.pemilikSaham,
        satuan: this.pemilikSatuan,
        vendorId: this.venId,
        fileKTP: ""
      };

      let fdata = new FormData();
      fdata.append("nama", this.pemilikNama);
      fdata.append("noKtp", this.pemilikKtp);
      fdata.append("alamat", this.pemilikAlamat);
      fdata.append("saham", this.pemilikSaham);
      fdata.append("satuan", this.pemilikSatuan);
      fdata.append("vendorId", this.venId);
      if (this.uploadFileKTP) fdata.append("fileKTP", this.uploadFileKTP);

      this.$store.dispatch('displayProgBar') 

      if (this.isEditing) {
        // update database
        this.submitting = true;

        await axios.put(apiUrl + "/vendor/pemilik/" + this.editId, fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
        .then( (response) => {
          this.$store.dispatch('displayAlert', {
            color: 'success', 
            message: `Data pemilik telah diperbarui!` 
          });

          const index = this.pos5List.findIndex(element => element.id === this.editId);
          if (index != -1) {
            newPemilik.id = response.data.id;
            newPemilik.fileKTP = response.data.fileKTP;
            this.pos5List.splice(index, 1, newPemilik);
          }
        })
        .catch( (error) => {
          console.error(error);
          if(error.response.status == 401) {
            this.loginExpired = true;
          }else if(error.response.status == 422) {
            this.loginExpired = true;
          }else {
            this.$store.dispatch('displayAlert', {color: 'error', message: `Error update data! ${error.message}`})
            window.scroll(0,0)
          }
        })
        .finally( () => {
          this.$store.dispatch('closeProgBar');
          this.submitting = false;
        });

      } else {
        // simpan ke database
        this.submitting = true;

        await axios.post(apiUrl + '/vendor/register3/pemilik', fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
        .then((response) => {
          this.$store.dispatch('displayAlert', {
            color: 'success', 
            message: `Data Pemilik sukses didaftarkan !` 
          });

          this.$store.dispatch('ven/assignVendor', response.data.data)
          this.$store.commit('reg/setStatusIjin', 'V')
          window.scroll(0,0)

          // proses response
          newPemilik.id = response.data.data.pemilikId;
          newPemilik.fileKTP = response.data.data.fileKTP;
          this.pos5List.push(newPemilik)
          this.pos5Count = this.pos5List.length
        })
        .catch((error) => {
          console.log(error)
          if(error.response.status == 401) {
            this.loginExpired = true;
          }else if(error.response.status == 422) {
            this.loginExpired = true;
          }else {
            this.$store.dispatch('displayAlert', {color: 'error', message: `Gagal menyimpan! ${error.message}`})
            window.scroll(0,0)
          }
        })
        .finally(() => {
          this.$store.dispatch('closeProgBar')
          this.submitting = false;
        });
      }
      

      this.closeForm();

    },
    resetForm5: function() {
      this.$refs.form5.reset()
    },
    getSahamText: function(saham, satuan) {
      if (satuan === 'P') {
        return `${saham} %`
      }
      else {
        return `${saham} Lembar`
      }
    },
    deletePemilik: async function(id) {
      // hapus database
      this.submitting = true;

      await axios.delete(apiUrl+`/vendor/pemilik/${id}`)
      .then((response) => {
        if (response.data.statusCode != 200) { // hapus gagal
          this.$store.dispatch('displayAlert', {color: 'error', message: 'Error dalam penghapusan data ! Silahkan coba beberapa saat lagi' })
          window.scroll(0,0)
        }
        else { // hapus berhasil
          // hapus element data table
          this.pos5List = this.pos5List.filter(function(el) {
            return el.id !== id;
          });
          this.pos5Count = this.pos5List.length;
        }
      })
      .catch((error) => {
        console.log( error)
        this.$store.dispatch('displayAlert', {color: 'error', message: 'Error dalam penghapusan data ! Silahkan coba beberapa saat lagi' })
      })  
      .finally( () => {
        this.submitting = false;
      })
    },
    logoutClick: function() {
        this.$store.dispatch('logout')
        .then(() => {
            this.$router.push('/')
        })
    },
  },
  created: async function() {
    this.$store.dispatch('displayPageTitle', 'Pemilik Perusahaan')
    await axios.get(apiUrl+'/vendor/pemilik/'+this.venId)
    .then((response) => {
      if (response.data.statusCode != 200) {
        this.pos5List = []
      }
      else {
        response.data.data.forEach(element => {
          this.pos5List.push(element)
        })              
      }
      this.pos5Count = this.pos5List.length
    })
    .catch((error) => {
      console.log(error)
    })  
  }

}
</script>

<style>

</style>